import React, { FC, useState } from 'react';
import { observer } from 'mobx-react-lite';
import cn from 'classnames';
import { useStores } from 'hooks/useStores';
import Button from 'ati-ui-react/components/Button';
import DatePicker from 'generic/DatePicker';
import { formatRangeForDatePiker } from 'utils/formatRange';
import sortBy from 'lodash/sortBy';
import calendarIcon from './calendar.svg';

import { AvailabilityDateStyles } from './AvailabilityDateStyles';

interface IAvailabilityDate {
  className?: string;
}

const AvailabilityDate: FC<IAvailabilityDate> = observer(({ className }) => {
  const {
    appStore: { isMobile },
    advertsStore: {
      currentAdvert: { busy_date_ranges },
    },
  } = useStores();
  const [isOpenPopup, setOpenPopup] = useState(false);

  const ranges = busy_date_ranges
    ? formatRangeForDatePiker(sortBy(busy_date_ranges, (date) => date.from))
    : null;
  if (!ranges) return null;

  return (
    <AvailabilityDateStyles className={cn(className)}>
      <Button
        simple
        simpleDashed
        onClick={() => setOpenPopup(true)}
        before={<img alt="truckmarket" src={calendarIcon} width="16" height="16" />}
      >
        {isMobile ? 'Календарь доступности аренды' : 'Посмотреть календарь доступности аренды'}
      </Button>
      {isOpenPopup && (
        <DatePicker
          title="Календарь доступности аренды"
          onClose={() => setOpenPopup(false)}
          readOnly
          ranges={ranges}
        />
      )}
    </AvailabilityDateStyles>
  );
});

export default AvailabilityDate;
